var React = require('react');

function DocumentCode (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0}),React.createElement("desc",{"key":1}),React.createElement("defs",{"key":2}),React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"none","strokeWidth":"1","key":3},React.createElement("g",{"fill":"#929292"},React.createElement("path",{"d":"M19.5,3 L9.00276013,3 C7.89666625,3 7,3.89833832 7,5.00732994 L7,27.9926701 C7,29.1012878 7.89092539,30 8.99742191,30 L24.0025781,30 C25.1057238,30 26,29.1017876 26,28.0092049 L26,10.5 L26,10 L20,3 L19.5,3 L19.5,3 L19.5,3 Z M19,4 L8.9955775,4 C8.44573523,4 8,4.45526288 8,4.99545703 L8,28.004543 C8,28.5543187 8.45470893,29 8.9999602,29 L24.0000398,29 C24.5523026,29 25,28.5550537 25,28.0066023 L25,11 L20.9979131,11 C19.8944962,11 19,10.1134452 19,8.99408095 L19,4 L19,4 Z M20,4.5 L20,8.99121523 C20,9.54835167 20.4506511,10 20.9967388,10 L24.6999512,10 L20,4.5 L20,4.5 Z M17,18 L15,26 L16,26 L18,18 L17,18 L17,18 Z M13,25 L10,22 L13,19 L13.6999998,19.6999998 L11.3999996,22 L13.6999998,24.3000002 L13,25 L13,25 Z M20,25 L23,22 L20,19 L19.3000002,19.6999998 L21.6000004,22 L19.3000002,24.3000002 L20,25 L20,25 Z"})))]);
}

DocumentCode.displayName = "DocumentCode";

DocumentCode.defaultProps = {"height":"32px","version":"1.1","viewBox":"0 0 32 32","width":"32px"};

module.exports = DocumentCode;

DocumentCode.default = DocumentCode;



//////////////////
// WEBPACK FOOTER
// ./src/components/Work/document-code.svg
// module id = 22
// module chunks = 0